import { mapGetters } from 'vuex';
import hasClubhousePermission from '@/utils/hasClubhousePermission';
import { clubmemberPermissions } from '@/lib/constants';

export default {
  data() {
    return {
      canViewMetrics: false,
      canEmail: false,
      canViewSeasons: false,
      calledPermissions: false,
      calledList: false,
    };
  },

  created() {
    //* non-reactive constants
    this.$options.clubmemberPermissions = clubmemberPermissions;
  },

  mounted() {
    if (this.isAuthenticated) {
      this.$store.dispatch('users/clubPermissions');
    }
  },

  computed: {
    ...mapGetters('authentication', ['isAuthenticated']),
    ...mapGetters('users', ['getMe', 'clubPermissions']),
    ...mapGetters('clubhouses', ['list', 'getClubhouse']),

    clubhouseData() {
      const { clubhouseID } = this.$route.params;
      // const { clubhouseID, id: eventID } = this.$route.params;
      if (!this.$route.path.includes('clubhouse')) {
        return {};
      }

      // if (eventID) {
      //   this.$store.dispatch('events/show', { id: eventID }).then((res) => {
      //     console.log('res:', res);
      //   });
      // }

      if (!this.list.length && !this.calledList) {
        this.$store.dispatch('clubhouses/list').then((res) => {
          this.calledList = true;
        });
      }

      const currentClub = this.list?.find((club) => {
        return club?.id?.toString() === clubhouseID?.toString();
      });
      return currentClub;
    },

    isClubOwner() {
      const clubhouse = this.$store.getters['users/getClubhouse'];
      const clubhouseID = clubhouse?.id?.toString();
      const routeClubhouseID = this.$route?.params?.clubhouseID?.toString();

      if (clubhouseID === undefined || routeClubhouseID === undefined) {
        return false;
      }

      const isOwnerClub = clubhouse && clubhouseID === routeClubhouseID;
      return isOwnerClub;
    },

    canViewToolbar() {
      if (!this.clubPermissions?.length && this.isAuthenticated && !this.calledPermissions) {
        this.$store.dispatch('users/clubPermissions').then((res) => {
          this.calledPermissions = true;
        });
      }

      if (!this.clubPermissions?.length && this.calledPermissions) {
        return false;
      }

      const permissionCheck = hasClubhousePermission(
        this.clubPermissions,
        this.$options.clubmemberPermissions,
        this.getMe,
        this.clubhouseData
      );
      return permissionCheck || this.isClubOwner;
      // return true;
    },

    hasClubAdminPermission() {
      const permissionCheck = hasClubhousePermission(
        this.clubPermissions,
        ['ADMIN'],
        this.getMe,
        this.clubhouseData
      );
      permissionCheck ? (this.canViewMetrics = true) : (this.canViewMetrics = false);
      return permissionCheck;
    },

    hasClubMetricsPermission() {
      const permissionCheck = hasClubhousePermission(
        this.clubPermissions,
        ['METRICS'],
        this.getMe,
        this.clubhouseData
      );
      // console.log('permissionCheck:', permissionCheck);
      permissionCheck ? (this.canViewMetrics = true) : (this.canViewMetrics = false);
      return permissionCheck;
    },

    hasClubEmailPermission() {
      const permissionCheck = hasClubhousePermission(
        this.clubPermissions,
        ['EMAIL'],
        this.getMe,
        this.clubhouseData
      );
      // console.log('permissionCheck:', permissionCheck);
      permissionCheck ? (this.canEmail = true) : (this.canEmail = false);
      return permissionCheck;
    },

    hasClubSeasonsPermission() {
      const permissionCheck = hasClubhousePermission(
        this.clubPermissions,
        ['SEASONS'],
        this.getMe,
        this.clubhouseData
      );
      // console.log('Seasons permissionCheck:', permissionCheck);
      permissionCheck ? (this.canViewSeasons = true) : (this.canViewSeasons = false);
      return permissionCheck;
    },

    hasClubFitterPermission() {
      const permissionCheck = hasClubhousePermission(
        this.clubPermissions,
        ['CLUBFITTER'],
        this.getMe,
        this.clubhouseData
      );
      permissionCheck ? (this.canViewSeasons = true) : (this.canViewSeasons = false);
      return permissionCheck;
    },

    currentClubhouse() {
      if (!this.getClubhouse?.id) {
        return this.clubhouseData;
      }
      return this.getClubhouse;
    },
  },

  methods: {},
};
